var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import "../../../../models/index.js";
import { getFetchArgs, providesList } from "../../utils.js";
import { notificationHubApi, notificationHubV1Api } from "../api.js";
import { NOTIFICATION_HUB_URL_SEGMENTS, apiVersion, NOTIFICATION_HUB_TAGS } from "../common.js";
import { SUBSCRIPTION_TYPES } from "../../../../models/SubscriberModels.js";
const resource = NOTIFICATION_HUB_URL_SEGMENTS.NOTIFICATION_SUBSCRIPTIONS;
const notificationSubscriptionsApi = notificationHubApi.injectEndpoints({
  endpoints: (builder) => ({
    queryAdminSubscribers: builder.query({
      query: (payload) => getFetchArgs({
        resource,
        payload,
        apiVersion,
        additionalQueryParams: {
          skip: payload.skip,
          top: payload.top,
          notificationSubscriptionType: SUBSCRIPTION_TYPES.Admin,
          notificationCategory: payload.notificationCategory
        }
      }),
      providesTags: (result) => {
        var _a, _b, _c;
        return [
          ...providesList(result == null ? void 0 : result.value, NOTIFICATION_HUB_TAGS.SUBSCRIBERS, true),
          ...(_b = (_a = result == null ? void 0 : result.value) == null ? void 0 : _a.flatMap(
            (s) => {
              var _a2;
              return (_a2 = s.subscribers) == null ? void 0 : _a2.map((sub) => ({ type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS, id: sub.id }));
            }
          )) != null ? _b : [],
          ...(_c = result == null ? void 0 : result.value.filter((s) => s.entityId).map((s) => ({
            type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS,
            id: s.entityId
          }))) != null ? _c : []
        ];
      }
    }),
    querySubscribers: builder.query({
      query: (payload) => getFetchArgs({
        resource,
        payload,
        apiVersion,
        additionalQueryParams: {
          skip: 0,
          top: 1,
          notificationSubscriptionType: SUBSCRIPTION_TYPES.EntityBase,
          entityType: payload.entityType,
          entityId: payload.entityExternalId
        }
      }),
      providesTags: (result, meta, payload) => {
        var _a, _b, _c;
        return [
          { type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS, id: payload.entityExternalId },
          ...providesList(result == null ? void 0 : result.value, NOTIFICATION_HUB_TAGS.SUBSCRIBERS, false),
          ...(_b = (_a = result == null ? void 0 : result.value) == null ? void 0 : _a.flatMap(
            (s) => {
              var _a2;
              return (_a2 = s.subscribers) == null ? void 0 : _a2.map((sub) => ({ type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS, id: sub.id }));
            }
          )) != null ? _b : [],
          ...(_c = result == null ? void 0 : result.value.filter((s) => s.entityId).map((s) => ({
            type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS,
            id: s.entityId
          }))) != null ? _c : []
        ];
      }
    }),
    updateSubscribers: builder.mutation({
      query: (payload) => getFetchArgs({
        resource,
        method: "PUT",
        apiVersion,
        payload: {
          id: payload.notificationSubscription.id,
          entity: payload.notificationSubscription,
          workspaceId: payload.workspaceId
        }
      }),
      invalidatesTags: (result, error, payload) => {
        var _a, _b;
        return [
          { type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS, id: payload.notificationSubscription.entityId },
          { type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS, id: payload.notificationSubscription.id },
          { type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS, id: result == null ? void 0 : result.entityId },
          { type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS, id: result == null ? void 0 : result.id },
          ...(_a = result == null ? void 0 : result.subscribers.map((sub) => ({ type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS, id: sub.id }))) != null ? _a : [],
          ...(_b = payload.notificationSubscription.subscribers.map((sub) => ({
            type: NOTIFICATION_HUB_TAGS.SUBSCRIBERS,
            id: sub.id
          }))) != null ? _b : []
        ];
      }
    })
  })
});
const notificationSubscriptionsV1Api = notificationHubV1Api.injectEndpoints({
  endpoints: (builder) => ({
    searchSubscribers: builder.query({
      query: (payload) => {
        var _a, _b;
        return getFetchArgs({
          resource: resource + "/subscribers/search",
          apiVersion,
          payload,
          additionalQueryParams: __spreadValues({
            searchStr: payload.searchString,
            count: (_a = payload.count) != null ? _a : 1,
            fetchUserPhoto: (_b = payload.fetchPhoto) != null ? _b : true
          }, payload.domains ? { domains: payload.domains } : {})
        });
      }
    })
  })
});
const {
  usePrefetch: usePrefetchNotificationSubscriptions,
  useQueryAdminSubscribersQuery,
  useQuerySubscribersQuery,
  useUpdateSubscribersMutation,
  useLazyQueryAdminSubscribersQuery,
  useLazyQuerySubscribersQuery
} = notificationSubscriptionsApi;
const {
  usePrefetch: usePrefetchNotificationSubscriptionsV1,
  useSearchSubscribersQuery,
  useLazySearchSubscribersQuery
} = notificationSubscriptionsV1Api;
export {
  notificationSubscriptionsApi,
  notificationSubscriptionsV1Api,
  useLazyQueryAdminSubscribersQuery,
  useLazyQuerySubscribersQuery,
  useLazySearchSubscribersQuery,
  usePrefetchNotificationSubscriptions,
  usePrefetchNotificationSubscriptionsV1,
  useQueryAdminSubscribersQuery,
  useQuerySubscribersQuery,
  useSearchSubscribersQuery,
  useUpdateSubscribersMutation
};
//# sourceMappingURL=notification-subscriptions.js.map
